// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__V2xDK","detailsBorder":"styles_detailsBorder__2cCKo"};